"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextStyles = void 0;

var _styledComponents = require("styled-components");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";\n    font-family: var(--font-family-secondary);\n    margin: ", ";\n    line-height: 1;\n    z-index: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    color: ", ";\n    text-transform: ", ";\n    text-align: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var auto = _ref2.auto;
  return auto ? '0 auto' : 0;
}, function (_ref3) {
  var zIndex = _ref3.zIndex;
  return "".concat(zIndex);
}, function (_ref4) {
  var size = _ref4.size;
  if (size) return "var(--font-size-".concat(size, ")");else {
    return 'var(--font-size-xs)';
  }
}, function (_ref5) {
  var weight = _ref5.weight;
  if (weight) return "var(--font-weight-".concat(weight, ")");else return 'var(--font-weight-normal)';
}, function (_ref6) {
  var color = _ref6.color;

  if (color === 'white') {
    return 'var(--color-base-white)';
  } else if (color === 'primary') {
    return 'var(--color-primary)';
  } else if (color === 'secondary') {
    return 'var(--color-secondary)';
  } else if (color === 'error') {
    return 'var(--color-red-600)';
  } else if (color === 'muted') {
    return 'var(--color-font-muted)';
  } else {
    return 'var(--color-font-base)';
  }
}, function (_ref7) {
  var transform = _ref7.transform;
  return transform;
}, function (_ref8) {
  var align = _ref8.align;
  return align;
});
exports.TextStyles = TextStyles;